import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiResponse } from "types/api";
import { MemberPayload, MemberVipResponseType } from "types/member";

import { VipPointsExchangePayload, VipPointsHistoryResponse } from "./type";

export const memberApi = {
  async getMemberVip(username: string, payload: MemberPayload) {
    const response = await axiosRequest.post<MemberVipResponseType>(
      "/",
      payloadHelper("MemberVIP", username, payload)
    );
    return response.data;
  },
  VipPointsExchange: async (payload: VipPointsExchangePayload) => {
    try {
      const response = await axiosRequest.post<ApiResponse>(
        "/",
        payloadHelper("VipPointsExchangeRequest", payload.username, payload)
      );
      return response.data;
    } catch (error) {
      throw new Error(error + "");
    }
  },
  VipPointsHistory: async (username: string) => {
    try {
      const response = await axiosRequest.post<VipPointsHistoryResponse>(
        "/",
        payloadHelper("VipPointsExchangeHistory", username, { username })
      );
      return response.data;
    } catch (error) {
      throw new Error(error + "");
    }
  }
};
